const ColoredText=({content})=>{
    return(
        <span className="bg-gradient-text-two bg-clip-text">
            {content}
        </span>
    )
}
export default ColoredText